import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en_filtering_library } from '@cern/hse-filtering-library';
import messagesEn from './translations/messages_en.json';

const resources = {
  en: {
    translation: {...messagesEn, ...en_filtering_library},
  },};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export const t = key => i18n.t(key);

export default i18n;
